<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="dialogVisible"
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`添加项目申报`"
            width="350px"
            center>
        <div class="dialog-container flex flex-direction">
            <el-form class="publish-form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="name"  label-width="0">
                    <el-input v-model="ruleForm.name" placeholder="请输入申报项目名称">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button  @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import { addApplyPro} from "@/api";
    export default {
        name: "AddProjectApplyDialog",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                id:0,
                loading: false,
                ruleForm: {
                    name: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入申报项目名称', trigger: 'blur'}
                    ],
                },
            }
        },
        created() {
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addItem();
                    }
                });
            },
            async addItem() {
                this.loading = true
                let _data = await addApplyPro(this.ruleForm.name)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState',true)
                }
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
        },
        watch: {
        }
    }
</script>

<style scoped lang="scss">

</style>